import keyBy from 'lodash/keyBy';
import { computed, type ComputedRef } from 'vue';

import type { MetaAdsAccount } from '@/app/analytics/instagram/insights/utils';

import { getCurrencyFromMetaAdsAccounts } from '@/app/analytics/instagram/utils';
import { wasAdsPlatformEverConnected } from '@/models/platform/connection-status';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';
import { usePlatformStore } from '@/stores/platform';

type MetaAdsAccountReader = {
  getAccount: (
    platform: unknown,
    options?: { brandId?: number },
  ) => MetaAdsAccount[] | null | undefined;
};

/** First platform-store ads account's currency; useMetaAdsAccountDetails reads the facebook store instead. */
export function getMetaAdsCurrency(platformStore: MetaAdsAccountReader): string | undefined {
  return getCurrencyFromMetaAdsAccounts(
    platformStore.getAccount(PLATFORM_CONNECTION.FACEBOOK_ADS_NEW),
  );
}

/** Platform-store ads accounts keyed by account_id; undefined until the platform was ever connected. */
export function useMetaAdsAccountsById(): ComputedRef<Record<string, MetaAdsAccount> | undefined> {
  const platformStore = usePlatformStore();
  return computed(() =>
    wasAdsPlatformEverConnected(platformStore, PLATFORM_CONNECTION.FACEBOOK_ADS_NEW)
      ? keyBy(platformStore.getAccount(PLATFORM_CONNECTION.FACEBOOK_ADS_NEW), 'account_id')
      : undefined,
  );
}
